<template>
  <div class="discount-banner w-100">
    <!-- Non-logged in user -->
    <div v-if="!isLoggedIn" class="banner-card">
      <div class="banner-left">
        <h2 class="raleway-semi-p15 mb-0">BIENVENUE CHEZ HORTENSE</h2>
        <div class="d-flex align-items-center" :class="isPhone ? 'flex-column' : 'flex-row'">
            <p class="raleway-reg-p15" :class="isPhone ? 'mt-2' : ''">
                {{ !isLoggedIn ? 'Avec le Club Hortense, accédez à des avantages exclusifs en vous connectant à votre espace client ou en créant votre compte gratuitement.' : 'Félicitations, bénéficiez de votre avantage en vous connectant ou créant votre compte gratuitement.'}}
            </p>
            <hr class="vertical-hr">
            <div class="banner-right">
                <div class="discount-badge">
                    <div class="discount-text" :class="isPhone ? 'merriweather-bold-p28' : 'merriweather-bold-p35'">-10% <span class="discount-subtext mb-2" :class="isPhone ? 'merriweather-reg-18' : 'merriweather-reg-20'">sur votre<br>premier séjour</span></div>
                </div>
            </div>
        </div>
        <div class="d-flex flex-column w-100 justify-content-center align-items-center" :class="isPhone ? 'mt-2' : ''">
            <button class="hortense-btn-primary mb-2" @click="$emit('showSignupModal')">CRÉER VOTRE COMPTE</button>
            <p class="raleway-reg-p11 text-muted mb-0">
            Vous avez un compte ? <a class="text-decoration-underline link-hortense" @click="$emit('showLoginModal')">Connectez-vous</a>
            </p>
        </div>
      </div>
    </div>

    <!-- Logged in user - code not used -->
    <div v-else-if="!isCodeUsed" class="banner-card">
      <div class="banner-left">
        <h2 class="raleway-semi-p15 mb-3">Bonjour {{ userName }},</h2>
        <p class="raleway-reg-p15 mb-2">
          Bienvenue dans le Club Hortense.
        </p>
        <p class="raleway-reg-p15 mb-2">
          Voici votre code de bienvenue : <span class="raleway-semi-p15 no-translate">BIENVENUE</span>.
        </p>
        <p class="raleway-reg-p15">
          Il vous permet de profiter de -10% sur votre première évasion éco-chic.
        </p>
      </div>
      <hr class="vertical-hr"></hr>
      <div class="banner-right">
        <div class="discount-badge">
          <div class="discount-text" :class="isPhone ? 'merriweather-bold-p28' : 'merriweather-bold-p35'">-10% <span class="discount-subtext mb-2" :class="isPhone ? 'merriweather-reg-18' : 'merriweather-reg-20'">sur votre<br>premier séjour</span></div>
        </div>
      </div>
    </div>

    <!-- Logged in user - code used -->
    <div v-else class="banner-card">
      <div class="banner-left">
        <h2 class="raleway-semi-p15 mb-3">Bonjour {{ userName }},</h2>
        <p class="raleway-reg-p15 mb-0    ">
          Parce que vous êtes membre du Club Hortense, chaque séjour devient un privilège. Découvrez les privilèges exclusifs de votre séjour.
        </p>
      </div>
      <hr class="vertical-hr"></hr>
      <div class="banner-right">
        <div class="discount-badge">
          <div class="discount-text merriweather-reg-20" style="line-height: 25px;">{{ privilegesText }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DiscountBanner',
  props: {
    isLoggedIn: {
      type: Boolean,
      default: false
    },
    isCodeUsed: {
      type: Boolean,
      default: false
    },
    userName: {
      type: String,
      default: 'INOM, PRÉNOM'
    },
    privilegesText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isPhone: false
    }
  },
  mounted() {
    this.checkIsPhone();
    window.addEventListener('resize', this.checkIsPhone);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkIsPhone);
  },
  methods: {
    checkIsPhone() {
      this.isPhone = window.innerWidth <= 768;
    }
  }
}
</script>

<style scoped lang="scss">
.discount-banner {
  margin-bottom: 2rem;
}

.banner-card {
  background: #FFFFFF;
  border-radius: 8px;
  box-shadow: 0px 3px 6px #00000029;
  padding: 21px 28px 21px 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.banner-card-simple {
  flex-direction: column;
  align-items: flex-start;
}

.banner-left {
  flex: 1;
}

.banner-left h2 {
  color: #000000;
  margin-bottom: 1rem;
}

.banner-left p {
  color: #000000;
  line-height: 1.6;
}

.banner-right {
  flex-shrink: 0;
  max-width: 25%;

  @media screen and (max-width: 768px) {
    max-width: 100%;
    width: 100%;
  }

  @media screen and (max-width: 1350px) {
    max-width: fit-content;
  }
}

.discount-badge {
  text-align: center;
  border-radius: 8px;
  min-width: 200px;
}

.discount-text {
  color: #3B6152;
  line-height: 1;
  margin-bottom: 0.5rem;
}

.discount-subtext {
  color: #3B6152;
  line-height: 1.4;
}

.text-muted {
  color: #6c757d;
}

.text-decoration-underline {
  text-decoration: underline;
  color: #3B6152;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mb-3 {
  margin-bottom: 1rem;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

@media (max-width: 768px) {
  .banner-card {
    flex-direction: column;
    align-items: flex-start;
  }

  .discount-badge {
    align-self: center;
  }
}

.vertical-hr {
  width: 1px;
  height: 100px;
  background-color: #ccc;
  border: none;
  margin: 0 2rem;

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 1px;
    margin: 1rem 0;
  }
}
</style>
